export const logout = {
  merge() {
    window.sessionStorage.clear();
    window.localStorage.clear();
    window.location.reload();
  },
};
